<div class="modal">
  <div class="modal-content">
    <div class="row header">
      <span> WARNING: Duplicate 4473 TTSN </span>
    </div>
    <div class="row small-text">
      <br />
      <br />
      <span>
        Duplicate Form 4473 Transferor's Transaction Serial Number (TTSN)
        identified.
      </span>
      <br />
      <br />
      <span>
        The TTSN for this transaction already exists in the BoundBook. If
        choosing to proceeded, the following items will be added to the existing
        record:
      </span>
      <br />
      <br />
      <br />
      <!-- Buttons -->
      <div class="button-container">
        <span class="item-header">
          Items associated with the existing TTSN:
        </span>
        <button class="btn-primary btn-sm btn button" (click)="proceedClick()">
          Proceed
        </button>
        <button
          class="btn-secondary btn-sm btn button"
          (click)="closeModalClick()"
          >
          Cancel
        </button>
      </div>
      <!-- Items -->
      @for (item of firearm_data; track item; let i = $index) {
        <div style="padding-bottom: 15px;">
          <div
            [ngClass]="{ 'odd-index': i % 2 !== 0, 'even-index': i % 2 === 0 }"
            >
            @if (
              item.a_importer &&
              item.a_importer !== '' &&
              item.a_importer !== 'N/A'
              ) {
              <span
                >Firearm: {{ item.a_importer }} - {{ item.a_model }} -
                {{ item.a_caliber_gauge }}</span
                >
              }
              @if (
                !item.a_importer ||
                item.a_importer === '' ||
                item.a_importer === 'N/A'
                ) {
                <span
                  >Firearm: {{ item.a_manufacture }} - {{ item.a_model }} -
                  {{ item.a_caliber_gauge }}</span
                  >
                  }<br />
                  <span>Firearm Serial Number: {{ item.a_serial_number }}</span
                    ><br />
                    @if (item.a_importer) {
                      <span
                        >Acquired From: {{ item.a_received_from_name }} on
                        {{ item.a_date_acquired | date : "MM/dd/yyyy" }}
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
